import { render, staticRenderFns } from "./CPModal.vue?vue&type=template&id=6abef7c2&scoped=true&"
import script from "./CPModal.vue?vue&type=script&lang=ts&"
export * from "./CPModal.vue?vue&type=script&lang=ts&"
import style0 from "./CPModal.vue?vue&type=style&index=0&id=6abef7c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abef7c2",
  null
  
)

export default component.exports